"use client";

import { motion } from "framer-motion";
import { PortableText } from "next-sanity";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PageManifestoSchema } from "@/sanity/pages/PageManifestoTemplate";
import { CTAButton } from "@/shadcn/ui/button";

const ease = [0.25, 0.1, 0.25, 1] as const;

export default function ConclusionSection({
  data,
}: {
  data: PageManifestoSchema;
}) {
  if (!data?.conclusionHeading && !data?.conclusionBody) return null;

  return (
    <section className="relative w-full flex flex-col items-center pt-[1rem] pb-[8rem] bg-white overflow-clip lg:pb-[10rem]">
      <div className="lg:w-[min(94.5rem,calc(100%-8rem))] w-[min(94.5rem,calc(100%-4rem))] py-[4rem] px-[4rem] flex flex-col items-center mx-auto border-[.125rem] border-black/10 lg:py-[9.63rem] lg:px-[12.75rem]">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease }}
          className="flex flex-col gap-[4.5rem] "
        >
          {data?.conclusionHeading && (
            <p className="mb-0 font-semibold text-black tracking-[-0.138rem] leading-[1.12] text-[3.5rem] lg:tracking-[-0.175rem]">
              {data.conclusionHeading}
            </p>
          )}

          {data?.conclusionBody && (
            <div className="richtext richtext-start flex flex-col gap-[1.5rem] prose-p:tracking-[-0.1rem]">
              <PortableText
                value={data.conclusionBody}
                components={richTextComponent}
              />
            </div>
          )}

          {data?.conclusionClosing && (
            <div className="richtext richtext-start flex flex-col gap-[1.5rem] prose-p:text-[2.5rem] prose-p:font-medium prose-p:tracking-[-0.125rem]">
              <PortableText
                value={data.conclusionClosing}
                components={richTextComponent}
              />
            </div>
          )}
          {data?.conclusionButton && (
            <motion.div
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease, delay: 0.55 }}
              className="w-full lg:w-fit"
            >
              <CTAButton data={data.conclusionButton} />
            </motion.div>
          )}
        </motion.div>
      </div>
    </section>
  );
}
